import React, { useState } from "react";
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


import styles from './SideDrawer.module.css';
import './Subdrawer.css';
// import { StylesContext } from "@material-ui/styles";





function SideDrawer(props) {

  const { open, handleDrawerClose, handleDrawerConfirmClose, sideOpen, title, ButtonLabel, body, SubDrawerbody,BackLabel } = props;




  // const [open, setOpen] = useState(false);
  // const handleDrawerOpen = () => {
  //   setOpen(true);
  // };
  // const handleDrawerClose = () => {
  //   setOpen(false);
  // };

  // onClick:handleDrawerOpen

  // <SideDrawer
  //     title="Student Details"
  //     ButtonLabel="View More Details" 
  //     sideOpen="right"
  //     open={open}
  //     handleDrawerClose={handleDrawerClose}

  //     body={
  //       <p>Drawer Details Place</p>
  //     }
  //   />

  return (
    <div>

      <Drawer
        anchor={sideOpen}
        open={open}
        handleDrawerClose={handleDrawerClose}
      >
        <div className={styles.DrawerContainer}>
          <div className={styles.DrawerHeader} style={{ background: props.Headerbackground }}>
          {props.BackArrow && <div className={styles.DrawerHeaderTitle} style={{ color: props.HeaderTextColor, cursor:props.cursor }} onClick={handleDrawerClose}><ArrowBackIosIcon style={{ color: props.HeaderTextColor }}/>{BackLabel}</div>}
            <div className={styles.DrawerHeaderTitle} style={{ color: props.HeaderTextColor,}}>{title}</div>
            <Button onClick={handleDrawerClose} ><CloseRoundedIcon style={{ color: props.HeaderTextColor }} /></Button>
          </div>

          <div className={styles.DrawerBody} style={{ width: props.DrawerWidth }}>

            <div className={props.SubDrawer}>
              {body}
              <div className="PM_SubDrawerInner">
                <div className="PM_SubDrawerBody">
                  {SubDrawerbody}
                </div>
              </div>
            </div>
          </div>

          {props.DrawerFooter &&
            <div className={styles.DrawerFooter}>
              <div className={styles.DrawerFooterInner}>
                {/* <Button className={styles.DrawerCloseButton} onClick={handleDrawerClose}>Close</Button> */}
                <Button className={styles.DrawerActionButton} onClick={handleDrawerConfirmClose}>{ButtonLabel}</Button>
                <Button className={styles.DrawerCloseButtonMobile} onClick={handleDrawerClose}>Close</Button>
              </div>
            </div>
          }
        </div>
      </Drawer>


    </div>
  );
}


export default SideDrawer;

